import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';

import { QuickRepliesCommonsModule } from './quick-replies-commons/quick-replies-commons.module';
import { ScenarioWizardComponent } from './scenario-wizard/scenario-wizard.component';
import { SocialNetworksModule } from './social-networks/social-networks.module';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [ScenarioWizardComponent],
  exports: [QuickRepliesCommonsModule, SocialNetworksModule],
})
export class ScenariosModule {}
